import dayjs from "dayjs";

export function getDiffInDays(date, now = dayjs()) {
	const date1 = dayjs(date);

	return Math.abs(Math.floor(date1.diff(now, "day")));
}

export function getDiffInHours(date, now = dayjs()) {
	const date1 = dayjs(date);

	return Math.floor(date1.diff(now, "hours"));
}

export function getDiffInMinutes(date, now = dayjs()) {
	const date1 = dayjs(date);

	return Math.floor(date1.diff(now, "hours"));
}
